import React from "react";

import "./ImageDecorator.css";

import hotCoals from "../../../shared/images/textures/hotcoals.png";
import castIron01 from "../../../shared/images/textures/castIron01.jpg";
import rust01 from "../../../shared/images/textures/rust01.jpg";

const ImageDecorator = function (props) {
    return (
        <div className="image-decorator-wrapper">
            <div className="image-decorator-img-shadow" style={{ backgroundImage: `url(${rust01})` }}></div>


            <span className="image-decorator-shadow-wrap">
                <img src={props.image}></img>
            </span>





            <div className="image-decorator-img-foreground-one" style={{ backgroundImage: `url(${props.image})` }} />


            <div className="image-decorator-img-foreground-two" />







        </div >

    )
}

export default ImageDecorator;